import { render, staticRenderFns } from "./ChangePassView.vue?vue&type=template&id=1673be34&"
import script from "./ChangePassView.vue?vue&type=script&lang=js&"
export * from "./ChangePassView.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports